import * as zxcvbnDePackage from '@zxcvbn-ts/language-de'
import type translations from "@zxcvbn-ts/language-de/dist/translations"

export default {
    ...zxcvbnDePackage.translations,
    warnings: {
        ...zxcvbnDePackage.translations.warnings,
        userInputs: 'Es sollten keine persönlichen Daten vorkommen.',
        pwned: 'Ihr Kennwort wurde durch eine Datenpanne im Internet offengelegt.'
    },
    suggestions: {
        ...zxcvbnDePackage.translations.suggestions,
        l33t: "Vermeide Buchstabenersetzungen wie '@' für 'a'.",
        reverseWords: 'Vermeide rückwärts geschriebene Wörter.',
        allUppercase: 'Verwende nicht nur Großbuchstaben.',
        capitalization: 'Nicht nur den ersten Buchstaben groß schreiben.',
        dates: 'Vermeide Daten, die mit persönlichen Daten in Verbindung gebracht werden können.',
        recentYears: 'Vermeide die jüngsten Jahreszahlen.',
        associatedYears: 'Vermeide Jahre, die mit persönlichen Daten in Verbindung gebracht werden können.',
        sequences: 'Vermeide häufige genutzte Zeichenfolgen.',
        repeated: 'Vermeide Wort- und Zeichenwiederholungen.',
        longerKeyboardPattern: 'Verwende längere Tastaturmuster in unterschiedlicher Tipprichtung.',
        anotherWord: 'Füge weitere Wörter oder Zeichen hinzu, die weniger häufig sind.',
        useWords: 'Verwende mehrere Wörter, aber vermeide allgemeine Phrasen.',
        noNeed: 'Es ist möglich, starke Passwörter zu erstellen, ohne Symbole, Zahlen oder Großbuchstaben zu verwenden.',
        pwned: 'Wenn Sie dieses Kennwort an anderer Stelle verwenden, sollten Sie es ändern.'
    },
} as typeof translations
